import { GetAccommodationsResponse } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useQuery } from '@tanstack/react-query'

export const useAccommodations = (tripId: string | undefined) => {
    return useQuery<GetAccommodationsResponse>({
        queryKey: queryKeys.accommodations(tripId),
        queryFn: async () => {
            if (!tripId) {
                throw new Error('Trip ID is required')
            }
            const response = await api.get<GetAccommodationsResponse>(`/trips/${tripId}/accommodations`)
            return response.data
        },
        enabled: !!tripId,
        retry: 1,
    })
}
